module.exports = __webpack_public_path__ + "static/img/MT@3x.e65859d8.jpg";